module.exports = __webpack_public_path__ + "static/media/bone-break.fb7676cc.svg";